import type { LegalDocType } from "@kawkaw/shared";
import { usePublicLegalDocument } from "../api/hooks";
import { MarkdownLite } from "./MarkdownLite";

export function LegalContentModal({ docType, onClose }: { docType: LegalDocType | null; onClose: () => void }) {
  const { data, isLoading } = usePublicLegalDocument(docType ?? "terms", docType != null);

  if (!docType) return null;

  return (
    <div
      className="admin-overlay fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        className="flex max-h-[80vh] w-full max-w-lg flex-col overflow-hidden rounded-2xl bg-white"
      >
        <div className="flex shrink-0 items-center justify-between border-b border-[#f1f5f9] px-5 py-4">
          <div className="text-base font-black text-[#191c1d]">{data?.data.title ?? (docType === "terms" ? "Terms and Conditions" : "Privacy Policy")}</div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="flex size-8 cursor-pointer items-center justify-center rounded-full border-none bg-[#f5f5f5] text-base text-[#737373] hover:bg-[#e5e5e5]"
          >
            ×
          </button>
        </div>
        <div className="overflow-y-auto px-5 py-4">
          {isLoading ? (
            <div className="py-8 text-center text-sm text-[#a3a3a3]">Loading…</div>
          ) : (
            <MarkdownLite content={data?.data.content ?? ""} />
          )}
        </div>
      </div>
    </div>
  );
}
